import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { SmsTemplate } from '../models/sms-template';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class SmsTemplatesService extends CrudService {
    /**
     * Constructeur
     **/
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<SmsTemplate>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        if (context === null) {
            return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/smstemplates`, httpOptions).pipe(
                map((x) => {
                    var res = Results.getCopyFrom<SmsTemplate>(SmsTemplate, x);
                    return res;
                })
            );
        } else {
            return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/views/${context.value}/smstemplates`, httpOptions).pipe(
                map((x) => {
                    var res = Results.getCopyFrom<SmsTemplate>(SmsTemplate, x);
                    return res;
                })
            );
        }
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/smstemplates/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }

    update(smsTemplateId: number, smsTemplate: SmsTemplate, global: boolean): Observable<SmsTemplate> {
        let url: string;

        if (global === true) {
            url = this.baseUrl + `/api/organizations/${this.organizationId}/smstemplates/${smsTemplateId}`;
        } else {
            url = this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/smstemplates/${smsTemplateId}`;
        }

        // Appel de la Web Api
        return this.http.put<SmsTemplate>(url, smsTemplate).pipe(
            map((x) => {
                return SmsTemplate.from(x);
            })
        );
    }

    delete(smsTemplateId: number, global: boolean): Observable<boolean> {
        let url: string;

        if (global === true) {
            url = this.baseUrl + `/api/organizations/${this.organizationId}/smstemplates/${smsTemplateId}`;
        } else {
            url = this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/smstemplates/${smsTemplateId}`;
        }

        // Appel de la Web Api
        return this.http.delete<SmsTemplate>(url, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return true;
            })
        );
    }

    add(smsTemplate: SmsTemplate, global: boolean): Observable<SmsTemplate> {
        let url: string;

        if (global === true) {
            url = this.baseUrl + `/api/organizations/${this.organizationId}/smstemplates`;
        } else {
            url = this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/smstemplates`;
        }

        // Appel de la Web Api
        return this.http.post<SmsTemplate>(url, smsTemplate).pipe(
            map((x) => {
                return SmsTemplate.from(x);
            })
        );
    }

    get(smsTemplateId: number): Observable<SmsTemplate> {
        // Appel de la Web Api
        return this.http.get<SmsTemplate>(this.baseUrl + `/api/organizations/${this.organizationId}/smstemplates/${smsTemplateId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return SmsTemplate.from(x);
            })
        );
    }
}
